import axios from 'axios'
import { MessageBox, Message } from 'element-ui'
import store from '@/store'
import router from '@/router'
import { getToken, removeToken } from '@/utils/auth'
import { organization } from '@/utils/common'

if (process.env.NODE_ENV == 'development') {//本地开发才输出该log提示
  console.log(organization)
}

// let baseUrl='';
// if (process.env.NODE_ENV == 'production') { //正式环境配置接口域名
//   baseUrl='http://course-api.yiihuu.com:81';
// }

// create an axios instance
const service = axios.create({
  baseURL: process.env.BASE_API, // url = baseURL + request url + organization.id
  // withCredentials: true, // send cookies when cross-domain requests
  timeout: 50000 // request timeout
})

// request interceptor
service.interceptors.request.use(
  config => {
    // do something before request is sent
    config.headers['X-ISAPI'] = 1
    if (location.hostname == 'aigc.yiihuu.com' || location.hostname =='aigc.goyor.com') config.headers['oid'] = process.env.BASE_APP_OID
    // config.headers['oid'] = process.env.BASE_APP_OID
    if (store.getters.token) {
      // let each request carry token
      // ['X-Token'] is a custom headers key
      // please modify it according to the actual situation
      config.headers['Authorization'] = 'Bearer ' + getToken()
    }

    // axios拦截器内url后统一添加机构id
    // if (config.addOrganizationid !== false && organization.id) { //未显式声明不需要添加机构id && 地址栏有机构id字段
    //   config.url = `${config.url + organization.id}/`;
    // }
    // console.log(config);

    return config
  },
  error => {
    // do something with request error
    console.log(error) // for debug
    return Promise.reject(error)
  }
)

// response interceptor
service.interceptors.response.use(
  response => {
    const res = response.data;
    if (res.status === true || res.returnMsg == "success") {
      return res
    } else {
      let isDataCode = response && response.data && response.data.error_code;
      if (response.data && response.data.returnCode) {
        // 处理监管平台
        return res
      } else if (isDataCode == '20000') {
        // 用户机构不存在
        router.push('/404page')
      } else if (isDataCode == '20002') {
        // 此用户机构已过期
        router.push('/expired')
      } else if (isDataCode == '30000') {
        // 用户访问的页面 返回没权限时,跳转至首页
        router.push('/')
      } else if (isDataCode == '4011') {
        // location.reload();
        // if (store.getters.is_home == 1) {
        removeToken();
        // router.push('/');
        // } else {
        //   router.push('/login');
        // }
      } else {
        Message({
          message: res.error_msg || 'Error',
          type: 'error',
          duration: 5 * 1000
        })
        console.log(`status:false,error_msg:${res.error_msg}`);
        return Promise.reject(new Error(res.error_msg || 'Error'))
      }
    }
  },
  error => {
    const http_code = error.response.status;//Status Code
    let error_msg = error.response.data.error_msg;
    let error_id = error.response.data.error_code;
    let isDataCode = error.response && error.response.data && error.response.data.error_code
    if (!error_msg) {
      error_msg = error.response.data.errors
    }
    console.log(`err! http_code:${http_code},error_msg:${error_msg}`)
    /*
    400:返回数据错误
    422：参数校验错误
    401： 身份验证，token 缺失 或 过期失效
    */
    if (isDataCode == '20000') {
      // 用户机构不存在
      router.push('/404page')
    } else if (isDataCode == '20002') {
      // 此用户机构已过期
      router.push('/expired')
    } else if (isDataCode == '30000') {
      // 用户访问的页面 返回没权限时,跳转至首页
      router.push('/')
    } else if (error_id == '4011') {
      removeToken();
      router.push('/');
    } else if (http_code === 400 && isDataCode != '10001' || http_code === 422 && isDataCode != '10001') {
      Message({
        message: error_msg,
        type: 'error',
        duration: 5 * 1000
      })
    } else if (isDataCode == 10001) {
      Message({
        message: error_msg,
        type: 'error',
        duration: 2 * 1000
      })
      return Promise.reject(isDataCode)
    } else if (http_code === 401) {
      // 清除cookie（yiihuu-Token）
      removeToken();
    } else {
      Message({
        message: error.message,
        type: 'error',
        duration: 5 * 1000
      })
    }
    return Promise.reject(error)
  }
)

export default service



// WEBPACK FOOTER //
// ./src/utils/request.js